import { DotArt } from "./dot-art";

const WORLD_MAP_ROWS = [
  "............................................................",
  "....................#####...................................",
  "..####..######......######.....####..####################..",
  ".###############.....####....########################......",
  "..###############.....##....##########################.....",
  "...##############...........#########################......",
  "....############.............#######################.......",
  ".....##########...............#####..###############.......",
  "......########.................####...####..#######........",
  ".......######..................#####...##.....####.........",
  "........####...................######..........###.........",
  ".........###...................########.........##.........",
  "..........##....................########.....#...#.........",
  ".................###............########......#............",
  "................#####............#######.....#..###........",
  "................######............######.........#.........",
  ".................######............####....................",
  ".................#####..............###.........####.......",
  "..................####..............##.........######......",
  "..................###...............#..........######......",
  "..................##.............................####.......",
  "..................##..............................#.....#...",
  "...................#........................................",
  "............................................................",
] as const;

interface WorldDotMapProps {
  className?: string;
}

export function WorldDotMap({ className }: WorldDotMapProps) {
  return <DotArt rows={WORLD_MAP_ROWS} radius={1.6} className={className} />;
}
